import { Directive, Input, HostListener } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Directive({
  selector: '[lpFormSubmitValidation]'
})
export class FormSubmitValidationMsgDirective {
  @Input() form: UntypedFormGroup;

  @HostListener('click', ["$event"])
  handleClickEvent(event: any) {
    this.markAsTouched(this.form);
  }

  private markAsTouched(formGroup: UntypedFormGroup): void {
    formGroup.markAsTouched();
    formGroup.updateValueAndValidity();
    (Object as any).values(formGroup.controls).forEach(
      (control: any) => {
        control.markAsTouched();
        control.updateValueAndValidity({ onlySelf: false, emitEvent: true });
        if (control.controls) {
          this.markAsTouched(control);
        }
      });
  }

}
